import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActiveSpace } from 'spaces/store/selectors';
import { closeModal } from 'modal/store/actions';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import MainTitle from 'base/components/MainTitle';
import Title3 from 'base/components/Title3';
import Button from 'base/components/Button';
import Col from 'base/components/Col';
import Row from 'base/components/Row';
import ModalHeader from 'modal/components/ModalHeader';
import { getEditingFolder, getActivePathStringWithSpace } from '../../store/folders/selectors';
import { getEntities } from '../../../store/entities/selectors';
import { deleteFolder } from '../../store/folders/actions';


const CreateFolderModal = ({
  name, folder, closeModal, deleteFolder, activePathString,
}) => (
  <>
    <ModalHeader>
      <MainTitle>Delete Folder</MainTitle>
    </ModalHeader>

    <FieldWrapper>
      Do you really want to delete
      <Title3>{activePathString}</Title3>
    </FieldWrapper>

    <FieldWrapper>
      This will also delete all its child folders and files.
    </FieldWrapper>

    <Row>
      <Col>
        <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
      </Col>
      <Col>
        <Button
          isFullWidth
          variant="primary"
          onClick={() => {
            deleteFolder(folder);
            closeModal(name);
          }}
        >
          Yes, delete
        </Button>
      </Col>
    </Row>
  </>
);
CreateFolderModal.propTypes = {
  name: PropTypes.string.isRequired,
  space: PropTypes.object.isRequired, // eslint-disable-line
  folder: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  deleteFolder: PropTypes.func.isRequired,
  activePathString: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  space: getActiveSpace(state),
  folder: getEditingFolder(state),
  activePathString: getActivePathStringWithSpace(state),
  entities: getEntities(state),
});

const mapDispatchToProps = {
  deleteFolder,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateFolderModal);
